import { Helmet } from "react-helmet-async";

export const SEO = ({ title, description }) => {
  const fullTitle = title ? `${title} | O.R.E.C` : "O.R.E.C — Our Ripple Effect Community";
  const desc = description || "O.R.E.C — a vetted community of spiritual, wellness, and values-driven practitioners in Calgary. Browse, learn, and book with people you can trust.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
    </Helmet>
  );
};
